import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import { useTranslation } from "react-i18next";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { sharedNextPage } from "../../../utils/shared-functions";
import Select from "react-select";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { disableEmpresa, enableEmpresa, obtenerEventosEmpresaPlataforma, } from "../../../api/api-empresa-plataforma";
// import { INT_TRUE, INT_FALSE } from "../../../utils/const/int-const";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// import { ClientSideRowModelModule } from "ag-grid-community"; // Import required module
// import { GridOptions, ModuleRegistry } from "ag-grid-community"; // Registry for modules
//import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
//import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS
import "../../../style/style-ag-grid.css";
import { COLOR_AZUL_MAIN, COLOR_VERDE } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
import { obtenerEquiposActivosPorEmpresaPlataforma } from "../../../api/api-empresa";
ModuleRegistry.registerModules([AllCommunityModule]);

// const idTipoUsuario = parseInt(localStorage.getItem("tipoUsuarioChecklist"));
let accesoBotonNuevo = '';


export default function ListEventosPlataforma() {

  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  const statusOptions = SELECT_HABILITADO_DESHABILITADO.map(option => ({
    value: option.value,
    label: t(option.label), // Ensure it matches translation keys
  }));
  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [isHovered, setIsHovered] = useState(false);
  const hoverColor = COLOR_AZUL_MAIN;

  const columnDefs = [
    {
      key: "acciones", headerName: "ACCIONES", width: 250,
      cellRenderer: (params) => {
        // console.log('cellRenderer');
        // console.log(params);
        return (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            {/* <button
                            onClick={() => handleEdit(params.data)}
                            style={{
                                backgroundColor: "#1E90FF",
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            {t("label_edit")}
                        </button> */}
          </div>
        );
      }
    },
    { field: "id", headerName: "ID", hide: true },
    { field: "idactivo", headerName: "ID ACTIVO", filter: true, sortable: true, },
    { field: "nombre", headerName: "NOMBRE", filter: true, sortable: true, },
    { field: "fechaprimerreporte", headerName: "FECHA PRIMER REPORTE", filter: true, sortable: true, width: 250, },
    { field: "fechaultimoreporte", headerName: "FECHA ULTIMO REPORTE", filter: true, sortable: true, width: 250, },
    { field: "montoInstalacion", headerName: t("column_monto_instalacion"), filter: true, width: 250, },
    { field: "montoServicio", headerName: t("column_monto_servicio"), filter: true, },
    { field: "moneda", headerName: t("column_moneda"), filter: true, },
    { field: "vendedor", headerName: t("column_vendedor"), filter: true, width: 300, },
    { field: "cantidadeventos", headerName: t("column_cantidad_eventos"), filter: true, width: 300, },
  ];

  useEffect(() => {
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      setPrimaryColor(mainColor);
    }
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log('data', data);
      const fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
      const fechaFin = moment().endOf("month").format("YYYY-MM-DD");
      let objEnviar = {};
      objEnviar.fechaInicio = fechaInicio;
      objEnviar.fechaFin = fechaFin;
      objEnviar.id = data.idEmpresaPlataforma;
      // console.log('objEnviar', objEnviar);
      // let permiso = null;
      // setTieneAccesoAlModulo(true);
      const response = await obtenerEventosEmpresaPlataforma(objEnviar)

      agregarAccionesALista(Array.isArray(response.body) ? response.body : [], null);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const agregarAccionesALista = (lista, permiso) => {
    try {
      setRowData(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleModalDeshabilitarModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await disableEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se deshabilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo deshabilitar');
      }
    }
  };

  const handleModalHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await enableEmpresa(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se habilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo habilitar');
      }
    }
  };

  const handleNuevoClick = () => {
    try {
      // console.log('handleNuevoClick');
      let obj = {};
      let data = {};
      data.id = 0;
      data.codigo = "";
      data.nombre = "";
      data.telefonoEmpresa = "";
      data.emailEmpresa = "";
      data.representante = "";
      data.telefonoRepresentante = "";
      data.emailRepresentante = "";
      data.timeZone = "";
      data.usuario = "";
      data.password = "";
      data.confirmarPassword = "";
      obj.titulo = "NUEVA EMPRESA";
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("empresa-plataforma", obj, history);
    } catch (err) {
      console.log('handleNuevoClick err');
      console.log(err);
    }
  };

  const onCellClicked = (data) => {
    try {
      console.log('onCellClicked', data);
      if (data.data.totalCobro !== undefined && data.data.totalCobro !== null && String(data.data.totalCobro).trim().length > 0) {
        const obj = {};
        obj.idEmpresaPlataforma = data.data.id;
        sharedNextPage("eventos-empresa-plataforma", obj, history);
      }
    } catch (err) {
      console.log('onCellClicked err', err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="p-4">
          <div className="flex justify-between">
            <label
              style={{
                // paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t("title_eventos")}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                {t("label_back")}
              </button>
            </div>
          </div>
          <div className="flex justify-between">
            <div>
            </div>
            <div className="">
              <label className="block">&nbsp;</label>
              <button
                type="button"
                className={`text-white font-semibold py-2 px-4 rounded`}
                style={{
                  backgroundColor: isHovered ? hoverColor : primaryColor,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => reset()}
              >
                {t("label_refresh")}
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine pt-4"
            style={{
              height: "512px",
              width: "100%",
              "--ag-header-background-color": `${primaryColor}`,
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              rowHeight={50}
              onCellClicked={onCellClicked}
            />
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleModalDeshabilitarModal}
            message={t("alert_disable_company")}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleModalHabilitarModal}
            message={t("alert_enable_company")}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
